export const config = {
  backendUrl: import.meta.env.VITE_BACKEND_URL ?? "http://localhost:8000",
  devUser: import.meta.env.VITE_DEV_USER ?? "",
  defaultModel: import.meta.env.VITE_DEFAULT_MODEL ?? "us.anthropic.claude-opus-4-6-v1",
  opusModel: import.meta.env.VITE_OPUS_MODEL ?? "us.anthropic.claude-opus-4-6-v1",
  env: import.meta.env.MODE,
  // OIDC (Cognito User Pool fronting IIC SAML). Empty in local dev; populated
  // in deployed envs by /config.json injected by the CDK frontend stack.
  cognitoAuthority: import.meta.env.VITE_COGNITO_AUTHORITY ?? "",
  cognitoClientId: import.meta.env.VITE_COGNITO_CLIENT_ID ?? "",
  cognitoSamlIdpName: import.meta.env.VITE_COGNITO_SAML_IDP_NAME ?? "",
  // Deployment-flavored UI copy. Defaults are deliberately generic so the
  // app reads as a plain "Bedrock Chat" until /config.json overrides them.
  appName: "Bedrock Chat",
  emptyStateTitle: "What would you like to know?",
  emptyStateBody: "",
  composerPlaceholder: "Ask a question…",
};

/**
 * Load /config.json (uploaded by the frontend CDK stack with deploy-resolved
 * values) and merge it into `config`. Skipped silently if the file is absent
 * (local Vite dev server) — env-var defaults take over.
 */
export async function loadRuntimeConfig(): Promise<void> {
  try {
    const r = await fetch("/config.json", { cache: "no-cache" });
    if (!r.ok) return;
    const ct = r.headers.get("content-type") ?? "";
    if (!ct.includes("application/json")) return;
    const body = (await r.json()) as Partial<typeof config>;
    for (const k of [
      "backendUrl",
      "env",
      "cognitoAuthority",
      "cognitoClientId",
      "cognitoSamlIdpName",
      "appName",
      "emptyStateTitle",
      "emptyStateBody",
      "composerPlaceholder",
    ] as const) {
      const v = body[k];
      if (typeof v === "string" && v) {
        // Lambda Function URLs come back with a trailing slash; strip it so
        // `${backendUrl}/api/...` doesn't collapse into `//api/...`.
        config[k] = k === "backendUrl" ? v.replace(/\/$/, "") : v;
      }
    }
  } catch {
    // network or parse error → keep defaults
  }
}

export function isOidcConfigured(): boolean {
  return Boolean(config.cognitoAuthority && config.cognitoClientId);
}
